import { combineReducers } from 'redux';
import { productionStandReducer } from './production-stand-new/ProductionStand.reducers';

export const protocolReducer = combineReducers({
    productionStand: productionStandReducer,
});
